import { type ReactNode, useCallback, useMemo, useState } from "react";

import { BreadcrumbContext, type BreadcrumbItem } from "./BreadcrumbContext";

export function BreadcrumbProvider({ children }: { children: ReactNode }) {
  const [breadcrumbs, setBreadcrumbsState] = useState<BreadcrumbItem[] | null>(null);
  const setBreadcrumbs = useCallback((items: BreadcrumbItem[] | null) => {
    setBreadcrumbsState(items);
  }, []);
  const value = useMemo(() => ({ breadcrumbs, setBreadcrumbs }), [breadcrumbs, setBreadcrumbs]);

  return <BreadcrumbContext.Provider value={value}>{children}</BreadcrumbContext.Provider>;
}
